import type { TTransportPerformanceSeriesRes } from 'api/swagger';
import type { TTransportPerformanceGroups } from 'shared/stores/helpers/transport-performance-groups-helper';
import { ALL_TAB_KEY } from 'shared/stores/use-transport-performance-groups';

export const filterSeriesByGroup = (
  series: TTransportPerformanceSeriesRes[],
  activeTab: string,
  groups: TTransportPerformanceGroups,
): TTransportPerformanceSeriesRes[] => {
  if (activeTab === ALL_TAB_KEY) {
    return series;
  }

  const groupIds = new Set(groups[activeTab] || []);
  return series.filter((item) => groupIds.has(item.id));
};
